import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container } from 'components'

import styles from './Header.module.css'

class Header extends Component {
  state = {
    expanded: false,
  }

  toggleExpand = () => {
    this.setState({
      expanded: !this.state.expanded,
    })
  }

  render() {
    const { title } = this.props
    const { expanded } = this.state

    return (
      <section className={styles.wrapper}>
        <Container>
          <span
            className={`${styles.title} ${expanded ? styles.expanded : null}`}
            onClick={this.toggleExpand}
          >
            {title}
          </span>
        </Container>
      </section>
    )
  }
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
}

export default Header
